import type { FormKitNode } from '@formkit/core'
import { whenAvailable, clone } from '@formkit/utils'

export default function autoHeightTextarea(node: FormKitNode) {
  if (node.props.type !== 'textarea') return

  node.addProps(['autoHeight', 'maxAutoHeight'])

  let inputElement: HTMLElement | undefined | null = null

  node.on('created', () => {
    if (!node.context) return
    if (!node.props.definition) return
    if (typeof node.props.definition?.schema !== 'function') return

    const inputDefinition = clone(node.props.definition)

    if (inputDefinition.schemaMemoKey) {
      inputDefinition.schemaMemoKey += '-auto-height'
    }

    node.props.definition = inputDefinition

    whenAvailable(node.context.id, () => {
      if (!node.context) return

      inputElement = node.props.__root?.getElementById(
        node?.context?.id ? node.context.id : ''
      )

      inputElement?.addEventListener('blur', (e: Event) => {
        const _payload = e!.target!.value.replace(/[\r\n]+/gm, '')
        if (!inputElement) return

        if (_payload.length === 0) {
          node.input('')
          inputElement.style.height = 'auto'
        }
      })
    })
  })

  node.on('input', () => {
    if (!inputElement) return
    inputElement.style.height = 'auto'
    inputElement.style.height = inputElement.scrollHeight + 'px'
  })
}
